import { User } from "../user";
import { Call } from "../../../../api/apiCall";

export const getUsers = async (
  email?: string,
  id?: number,
): Promise<Response> => {
  try {
    const res = await Call("users/get", "post", { email: email, id: id });

    if (res.ok) {
      return await res;
    } else {
      const errorData = await res.json();
      console.error("Errore API lato server:", errorData);
      return new Response(JSON.stringify(errorData), {
        status: res.status,
        headers: { "Content-Type": "application/json" },
      });
    }
  } catch (error) {
    console.error("Errore di rete:", error);
    return new Response(
      JSON.stringify({
        success: false,
        message: "Errore di rete o server non raggiungibile",
      }),
      {
        status: 500,
        headers: { "Content-Type": "application/json" },
      },
    );
  }
};
